import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
  Redirect,
  withRouter
} from 'react-router-dom'
import { Breadcrumb, Card } from 'antd';
import { Layout, Button, Divider } from "antd";
import Dashboard from './dashboard';
import Project from './projects';
import ProjectList from './projectlist';
import Events from './events';
import Login from './login';
import ScreenSaver from './screensaver';
import Media from './media';
import Landing from './landing';
import fakeAuth from './autha';

import ChangePW from './changepw';
import { auth } from '../firebase';

import "../App.css";
const ButtonGroup = Button.Group;


const Public = () => <h2>This page is public, no sign in required.</h2>

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={(props) => (
    fakeAuth.isAuthenticated === true
      ? <Component {...props} />
      : <Redirect to={{
        pathname: '/login',
        state: { from: props.location }
      }} />
  )} />
)

const AuthButton = withRouter(({ history }) => (
  fakeAuth.isAuthenticated ? (
    <div>
      <Card className='margin-low'>
        <div className='properp'>Welcome!</div>
        <Divider type="vertical" />
        <Button size="large" onClick={() => {
          auth.doSignOut().then(function () {
            // Sign-out successful.
            fakeAuth.signout(() => history.push('/'))
          }).catch(function (error) {
            console.log('signout error')
          })
        }}>Sign out
      </Button>
        <Divider type="vertical" />
        <Button type='primary' size='large' ghost><Link to='/changepw'>
          Change Password
        </Link></Button>
        <ButtonGroup size='large' className="np" >
          <Button type='primary' >
            <Link to='/dashboard/events'>
              Events
        </Link>
          </Button>
          <Button type='primary' >
            <Link to='/dashboard/projects'>
              Projects
        </Link>
          </Button>
          <Button type='primary' >
            <Link to='/dashboard/screensavers'>
              Screensavers
        </Link>
          </Button>
        </ButtonGroup>
      </Card>
    </div>
  ) : (
    <Card className='margin-low'>
      <p className='properp'>Tropicana Aman CMS</p>
    </Card>
  )
))








const breadcrumbNameMap = {
  '/admin': 'Admin',
  '/login': 'Login',
  '/dashboard': 'Dashboard',
  'packages': 'Packages',
  '/dashboard/events': 'Events',
  '/dashboard/projects': 'Projects',
  '/dashboard/screensavers': 'Screensavers',
  '/dashboard/projects/:id': 'ff',
};
const Bread = withRouter((props) => {
  const { location } = props;
  const pathSnippets = location.pathname.split('/').filter(i => i);
  // var id = pathSnippets[2];
  // console.log(pathSnippets)

  var name_packages = 'projectname';

  // if url is packages of individual project
  if (pathSnippets.length > 3) {
    // pathSnippets.splice(2, 1)
    name_packages = pathSnippets[3];
  }

  const extraBreadcrumbItems = pathSnippets.map((_, index) => {
    if (index === 2)
      return false
    var url = `/${pathSnippets.slice(0, index + 1).join('/')}`;

    // console.log('url' + url)
    if (url.includes('/packages')) {
      url = 'packages'
    }

    if (index === 3) {
      return (
        <Breadcrumb.Item key={url}>
          <Link to={url}>
            {name_packages}
          </Link>
        </Breadcrumb.Item>
      );
    } else {
      return (
        <Breadcrumb.Item key={url}>
          <Link to={url}>
            {index !== 2 ? breadcrumbNameMap[url] : name_packages}
          </Link>
        </Breadcrumb.Item>
      );
    }
  });

  const breadcrumbItems = [(
    <Breadcrumb.Item key="home">
      <Link to="/">Home</Link>
    </Breadcrumb.Item>
  )].concat(extraBreadcrumbItems);
  return (
    <Breadcrumb>
      {breadcrumbItems}
    </Breadcrumb>

  );
});


export default function AuthExample() {
  return (
    <Router>
      <div>
        <Layout className="App">
          <div className="oh">
            <AuthButton className="nq" />
          </div>
          <Card className='crumbb'>
            <Bread />
          </Card>

          <Switch>
            <Route path="/public" component={Public} />
            <PrivateRoute exact path="/" component={Dashboard} />
            <Route path="/login" component={Login} />
            <PrivateRoute exact path='/dashboard' component={Dashboard} />
            <PrivateRoute exact path='/changepw' component={ChangePW} />
            <PrivateRoute exact path='/admin' component={Landing} />

            <PrivateRoute exact path='/dashboard/projects' component={ProjectList} />
            <PrivateRoute path='/dashboard/projects/:id/:name' component={Project} />

            <PrivateRoute path='/dashboard/screensavers' component={ScreenSaver} />

            <PrivateRoute exact path='/dashboard/events' component={Events} />
            <PrivateRoute path='/dashboard/events/:id/:title' component={Media} />


            <Route component={Login} />
          </Switch>


        </Layout>
      </div>
    </Router>
  )
}


// WEBPACK FOOTER //
// ./src/views/home.js